exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-contain .v-slide-group__prev[data-v-58361922] {\n  display: none !important;\n}", ""]);

// exports
